import {Box, Typography} from '@mui/material'
import {blue, green, grey, orange, yellow} from '@mui/material/colors'
import React from 'react'

const GanttChart = () => {
  // Define the tasks and their durations
  const tasks = [
    // WP1: Data Source Assessment and Integration Framework (6 weeks)
    {
      id: 'WP1',
      name: 'WP1: Data Source Assessment and Integration',
      start: 1,
      duration: 6,
      category: 'wp',
      color: '#4472C4',
    },
    {
      id: 'WP1.1',
      name: 'Data Source Inventory and Evaluation',
      start: 1,
      duration: 2,
      category: 'task',
      parentId: 'WP1',
      color: '#5B9BD5',
    },
    {
      id: 'WP1.2',
      name: 'Data Quality Framework Development',
      start: 3,
      duration: 2,
      category: 'task',
      parentId: 'WP1',
      color: '#5B9BD5',
    },
    {
      id: 'WP1.3',
      name: 'Integration Architecture Design',
      start: 5,
      duration: 2,
      category: 'task',
      parentId: 'WP1',
      color: '#5B9BD5',
    },

    // WP2: Microgrid Modeling and AI/ML Algorithm Evaluation (8 weeks)
    {
      id: 'WP2',
      name: 'WP2: Microgrid Modeling and AI/ML Evaluation',
      start: 3,
      duration: 8,
      category: 'wp',
      color: '#ED7D31',
    },
    {
      id: 'WP2.1',
      name: 'Microgrid Model Comparison',
      start: 3,
      duration: 3,
      category: 'task',
      parentId: 'WP2',
      color: '#F4B183',
    },
    {
      id: 'WP2.2',
      name: 'AI/ML Algorithm Selection and Benchmarking',
      start: 6,
      duration: 3,
      category: 'task',
      parentId: 'WP2',
      color: '#F4B183',
    },
    {
      id: 'WP2.3',
      name: 'Integration Testing Framework',
      start: 9,
      duration: 2,
      category: 'task',
      parentId: 'WP2',
      color: '#F4B183',
    },

    // WP3: Uncertainty and Sensitivity Analysis (10 weeks)
    {
      id: 'WP3',
      name: 'WP3: Uncertainty and Sensitivity Analysis',
      start: 7,
      duration: 10,
      category: 'wp',
      color: '#A5A5A5',
    },
    {
      id: 'WP3.1',
      name: 'Uncertainty Categorization Framework',
      start: 7,
      duration: 2,
      category: 'task',
      parentId: 'WP3',
      color: '#D9D9D9',
    },
    {
      id: 'WP3.2',
      name: 'Sensitivity Analysis Methodology Development',
      start: 9,
      duration: 3,
      category: 'task',
      parentId: 'WP3',
      color: '#D9D9D9',
    },
    {
      id: 'WP3.3',
      name: 'Risk Assessment and Prioritization',
      start: 12,
      duration: 2,
      category: 'task',
      parentId: 'WP3',
      color: '#D9D9D9',
    },
    {
      id: 'WP3.4',
      name: 'Uncertainty Mitigation Strategy Research',
      start: 14,
      duration: 3,
      category: 'task',
      parentId: 'WP3',
      color: '#D9D9D9',
    },

    // WP4: Uncertainty Visualization Methodologies (6 weeks)
    {
      id: 'WP4',
      name: 'WP4: Uncertainty Visualization Methodologies',
      start: 13,
      duration: 6,
      category: 'wp',
      color: '#70AD47',
    },
    {
      id: 'WP4.1',
      name: 'Visualization Requirements Analysis',
      start: 13,
      duration: 2,
      category: 'task',
      parentId: 'WP4',
      color: '#A9D08E',
    },
    {
      id: 'WP4.2',
      name: 'Visualization Technique Evaluation',
      start: 15,
      duration: 2,
      category: 'task',
      parentId: 'WP4',
      color: '#A9D08E',
    },
    {
      id: 'WP4.3',
      name: 'Dashboard Design Specifications',
      start: 17,
      duration: 2,
      category: 'task',
      parentId: 'WP4',
      color: '#A9D08E',
    },

    // WP5: Market Participation Strategy Analysis (6 weeks)
    {
      id: 'WP5',
      name: 'WP5: Market Participation Strategy Analysis',
      start: 17,
      duration: 6,
      category: 'wp',
      color: '#FFC000',
    },
    {
      id: 'WP5.1',
      name: 'Market Monitoring System Requirements',
      start: 17,
      duration: 2,
      category: 'task',
      parentId: 'WP5',
      color: '#FFD966',
    },
    {
      id: 'WP5.2',
      name: 'Trading Algorithm Architecture',
      start: 19,
      duration: 2,
      category: 'task',
      parentId: 'WP5',
      color: '#FFD966',
    },
    {
      id: 'WP5.3',
      name: 'Financial Impact Assessment',
      start: 21,
      duration: 2,
      category: 'task',
      parentId: 'WP5',
      color: '#FFD966',
    },

    // Milestones
    {
      id: 'M1',
      name: 'Data Source Assessment Report',
      start: 9,
      duration: 0,
      category: 'milestone',
      color: '#000000',
    },
    {
      id: 'M2',
      name: 'Model & Algorithm Recommendations',
      start: 17,
      duration: 0,
      category: 'milestone',
      color: '#000000',
    },
    {
      id: 'M3',
      name: 'Uncertainty Analysis Report',
      start: 26,
      duration: 0,
      category: 'milestone',
      color: '#000000',
    },
    {
      id: 'M4',
      name: 'Visualization Specifications',
      start: 30,
      duration: 0,
      category: 'milestone',
      color: '#000000',
    },
    {
      id: 'M5',
      name: 'Market Strategy Recommendations',
      start: 35,
      duration: 0,
      category: 'milestone',
      color: '#000000',
    },
    {
      id: 'M6',
      name: 'Final Phase I Report',
      start: 39,
      duration: 0,
      category: 'milestone',
      color: '#000000',
    },
  ]

  // Calculate the project duration
  const weeksInProject = 39

  // Constants for rendering
  const rowHeight = 30
  const headerHeight = 50
  const labelWidth = 300
  const dayWidth = 15
  const totalWidth = labelWidth + weeksInProject * dayWidth
  const svgHeight = (tasks.length + 1) * rowHeight + headerHeight

  // Function to get y position for a task
  const getTaskY = (index: number) => headerHeight + (index + 1) * rowHeight - rowHeight / 2

  // Function to get bar height based on category
  const getBarHeight = (category: string) => {
    if (category === 'wp') return rowHeight - 10
    if (category === 'task') return rowHeight - 16
    return rowHeight - 12
  }

  // Function to get label offset based on category
  const getLabelOffset = (category: string) => {
    if (category === 'wp') return 5
    if (category === 'task') return 15
    return 0
  }

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      sx={{width: '100%', overflowX: 'auto', bgcolor: 'white', p: 4}}
    >
      <Box>
        <Typography variant={'h6'} fontWeight={700}>
          Microgrid Uncertainty Quantification Work Plan
        </Typography>
        <Box mt={1}>
          <Box display={'flex'} flexWrap={'wrap'} gap={2} mt={2}>
            <Box display={'flex'} alignItems={'center'}>
              <Box
                bgcolor={blue[500]}
                sx={{width: 10, height: 10, mr: 1}}
                className='w-4 h-4 bg-blue-500 mr-2'
              ></Box>
              <span>Data Assessment</span>
            </Box>
            <Box display={'flex'} alignItems={'center'}>
              <Box
                bgcolor={orange[500]}
                sx={{width: 10, height: 10, mr: 1}}
                className='w-4 h-4 bg-orange-500 mr-2'
              ></Box>
              <span>Modeling & ML</span>
            </Box>
            <Box display={'flex'} alignItems={'center'}>
              <Box
                bgcolor={grey[400]}
                sx={{width: 10, height: 10, mr: 1}}
                className='w-4 h-4 bg-gray-400 mr-2'
              ></Box>
              <span>Uncertainty Analysis</span>
            </Box>
            <Box display={'flex'} alignItems={'center'}>
              <Box
                bgcolor={green[500]}
                sx={{width: 10, height: 10, mr: 1}}
                className='w-4 h-4 bg-green-500 mr-2'
              ></Box>
              <span>Visualization</span>
            </Box>
            <Box display={'flex'} alignItems={'center'}>
              <Box
                bgcolor={yellow[500]}
                sx={{width: 10, height: 10, mr: 1}}
                className='w-4 h-4 bg-yellow-500 mr-2'
              ></Box>
              <span>Market Strategy</span>
            </Box>
            <Box display={'flex'} alignItems={'center'}>
              <Box
                bgcolor={'black'}
                sx={{width: 10, height: 10, mr: 1}}
                className='w-4 h-4 bg-black mr-2'
              ></Box>
              <span>Milestone Markers</span>
            </Box>
          </Box>
        </Box>
        <svg width={totalWidth} height={svgHeight} style={{border: '1px solid #ddd'}}>
          {/* Background grid */}
          {Array.from({length: weeksInProject + 1}).map((_, i) => (
            <line
              key={`grid-${i}`}
              x1={labelWidth + i * dayWidth}
              y1={headerHeight}
              x2={labelWidth + i * dayWidth}
              y2={svgHeight}
              stroke={i % 4 === 0 ? '#aaa' : '#eee'}
              strokeWidth='1'
            />
          ))}

          {/* Header */}
          <rect x='0' y='0' width={totalWidth} height={headerHeight} fill='#f5f5f5' />
          <text x='10' y='30' fontWeight='bold'>
            Tasks
          </text>

          {/* Week numbers */}
          {Array.from({length: Math.ceil(weeksInProject / 4)}).map((_, i) => (
            <text key={`month-${i}`} x={labelWidth + i * 4 * dayWidth + 5} y='30' fontWeight='bold'>
              M{i + 1}
            </text>
          ))}

          {/* Week markers */}
          {Array.from({length: weeksInProject}).map((_, i) => (
            <text key={`week-${i}`} x={labelWidth + i * dayWidth + 5} y='45' fontSize='10'>
              {i + 1}
            </text>
          ))}

          {/* Task rows */}
          {tasks.map((task, index) => (
            <React.Fragment key={task.id}>
              {/* Task labels */}
              <text
                x={getLabelOffset(task.category) + 10}
                y={getTaskY(index) + 5}
                fontWeight={task.category === 'wp' ? 'bold' : 'normal'}
                fontSize={task.category === 'milestone' ? '10' : '12'}
              >
                {task.name}
              </text>

              {/* Task bars or milestone markers */}
              {task.category === 'milestone' ? (
                <polygon
                  points={`
                  ${labelWidth + task.start * dayWidth - 5},${getTaskY(index)}
                  ${labelWidth + task.start * dayWidth},${getTaskY(index) - 8}
                  ${labelWidth + task.start * dayWidth + 5},${getTaskY(index)}
                  ${labelWidth + task.start * dayWidth},${getTaskY(index) + 8}
                `}
                  fill={task.color}
                />
              ) : (
                <rect
                  x={labelWidth + task.start * dayWidth}
                  y={getTaskY(index) - getBarHeight(task.category) / 2}
                  width={task.duration * dayWidth}
                  height={getBarHeight(task.category)}
                  fill={task.color}
                  rx='2'
                  ry='2'
                />
              )}
            </React.Fragment>
          ))}

          {/* Horizontal row separators */}
          {Array.from({length: tasks.length + 1}).map((_, i) => (
            <line
              key={`row-${i}`}
              x1='0'
              y1={headerHeight + i * rowHeight}
              x2={totalWidth}
              y2={headerHeight + i * rowHeight}
              stroke='#ddd'
              strokeWidth='1'
            />
          ))}

          {/* Vertical divider between labels and chart */}
          <line
            x1={labelWidth}
            y1='0'
            x2={labelWidth}
            y2={svgHeight}
            stroke='#aaa'
            strokeWidth='1'
          />
        </svg>
      </Box>
    </Box>
  )
}

export default GanttChart
